import { countriesMap, ICountriesMap } from '@lib/countriesMap';
import { IFilterOption } from '@types';

export const MAX_OPTIONS_SHOWN = 10;
export const MAX_CATEGORIES_OPTIONS_SHOWN = 15;

export function sortByChecked(a: IFilterOption, _b: IFilterOption) {
  if (a.isChecked) {
    return -1;
  }
  return 0;
}

export function sortAlphabeticallyByLabel(a: IFilterOption, b: IFilterOption) {
  if (a.label && b.label) {
    return a.label.localeCompare(b.label);
  }
  return 0;
}

export function sortSizesByLabel(a: IFilterOption, b: IFilterOption) {
  const order = ['s', 'm', 'l', 'xl'];
  return order.indexOf(a.value) - order.indexOf(b.value);
}

export function sortAlphabeticallyByValue(
  a: IFilterOption<string, string | JSX.Element>,
  b: IFilterOption<string, string | JSX.Element>
) {
  if (a.value && b.value) {
    return a.value.localeCompare(b.value);
  }
  return 0;
}

export function sortNumericByValue(a: IFilterOption<number>, b: IFilterOption<number>) {
  if (a.value && b.value) {
    return a.value - b.value;
  }
  return 0;
}

export function sortCountriesByName(a: IFilterOption<ICountriesMap>, b: IFilterOption<ICountriesMap>) {
  if (countriesMap[a.value] && countriesMap[b.value]) {
    return countriesMap[a.value].name.toLowerCase().localeCompare(countriesMap[b.value].name.toLowerCase());
  }
  return 0;
}

export function sortByProductsCountDesc<T extends { productsCount: number }>(a: T, b: T): number {
  return b.productsCount - a.productsCount;
}
